import React from 'react';
import './adminUi.css';

export function AdminToolbar(props: {
    left?: React.ReactNode;
    right?: React.ReactNode;
}) {
    return (
        <div className="adminToolbar">
            <div className="adminToolbarGroup">{props.left}</div>
            <div className="adminToolbarGroup">{props.right}</div>
        </div>
    );
}